import React from 'react'
import { ArrowUp, ArrowDown } from 'lucide-react'

const floatBtn = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 40,
  height: 40,
  borderRadius: 10,
  border: '1px solid #334155',
  backgroundColor: '#0f172a',
  color: '#eab308',
  cursor: 'pointer',
  boxShadow: '0 6px 20px rgba(0, 0, 0, 0.45)',
  transition: 'background-color 0.15s, transform 0.15s',
}

/**
 * Fixed up/down controls that scroll a ScrollableTableShell (or any scrollable element) by ref.
 */
export default function TableScrollFab({ scrollRef }) {
  const scrollToTop = () => {
    scrollRef?.current?.scrollTo({ top: 0, behavior: 'smooth' })
  }
  const scrollToBottom = () => {
    const el = scrollRef?.current
    if (el) el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' })
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: 900,
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        pointerEvents: 'none',
      }}
    >
      <button
        type="button"
        title="Scroll table to top"
        onClick={scrollToTop}
        style={{ ...floatBtn, pointerEvents: 'auto' }}
        onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = '#1e293b'
          e.currentTarget.style.transform = 'scale(1.05)'
        }}
        onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = '#0f172a'
          e.currentTarget.style.transform = 'none'
        }}
      >
        <ArrowUp size={18} strokeWidth={2.5} />
      </button>
      <button
        type="button"
        title="Scroll table to bottom"
        onClick={scrollToBottom}
        style={{ ...floatBtn, pointerEvents: 'auto' }}
        onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = '#1e293b'
          e.currentTarget.style.transform = 'scale(1.05)'
        }}
        onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = '#0f172a'
          e.currentTarget.style.transform = 'none'
        }}
      >
        <ArrowDown size={18} strokeWidth={2.5} />
      </button>
    </div>
  )
}
